<style scoped>
.confirm-order {
    & h1 {
        @apply text-left text-xl font-black;
    }
    & h1:after {
        content: '';
        @apply mt-4 mb-4 block border-b border-gray-100;
    }
    & ul {
        counter-reset: item;
        @apply text-sm font-bold list-inside list-disc;
    }
}
</style>

<template>
    <modal
        type="confirm"
        :class="modalClass"
        :cancelText="$t('common.cancel')"
        :confirmText="$t('common.confirm')"
        @confirm="$emit('confirm')"
        @cancel="$emit('cancel')"
    >
        <div class="confirm-order">
            <template v-if="!!needPayment">
                <h1>
                    {{ confirmPaymentModalTitle }}
                </h1>
                <ul>
                    <li>
                        {{ $t('order.confirm.remind.message.1') }}
                    </li>
                    <li v-if="paymentOption.pymtSrvcPrvdId !== 'CASH'">
                        {{ $t('order.confirm.remind.message.2') }}
                    </li>
                </ul>
            </template>
            <template v-if="!needPayment">
                <h1>
                    {{ $t('order.confirm') }}
                </h1>
                <ul>
                    <li>
                        {{ $t('order.confirm.remind.message.no.payment') }}
                    </li>
                </ul>
            </template>
        </div>
    </modal>
</template>

<script>
import modal from './modal.vue';

export default {
    components: { modal },
    props: {
        modalClass: { type: String, default: 'modal-secondary' },
        needPayment: { type: Boolean, required: true },
        paymentOption: { type: Object }
    },
    computed: {
        paymentName() {
            return this.paymentOption
                ? this.$t(
                      `order.payment.method.${this.paymentOption.pymtSrvcPrvdId}.${this.paymentOption.pymtMthdId}`
                  )
                : '';
        },
        confirmPaymentModalTitle() {
            if (this.paymentOption.pymtSrvcPrvdId === 'CASH') {
                return this.$t('order.confirm.pay.by.cash');
            }

            return this.$t('order.confirm.payment.method', this.paymentName);
        }
    }
};
</script>
